import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLock } from '@fortawesome/free-solid-svg-icons'

export default function PageExpired () {
    return (
        <div className='flex flex-col gap-5 justify-center items-center h-screen w-full text-gray-600 bg-gray-200'>
            <div className='flex gap-2 justify-center items-center text-4xl'>
                <FontAwesomeIcon icon={faLock} />
                 <p>This page already expired.</p>
            </div>
        </div>
    )
}